import { render, staticRenderFns } from "./addStaffCommunity.vue?vue&type=template&id=056d161b&scoped=true"
import script from "./addStaffCommunity.vue?vue&type=script&lang=js"
export * from "./addStaffCommunity.vue?vue&type=script&lang=js"
import style0 from "./addStaffCommunity.vue?vue&type=style&index=0&id=056d161b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d161b",
  null
  
)

export default component.exports